export const SET_SIDEBAR_WIDTH = 'SET_SIDEBAR_WIDTH';
